

import { getPageTitle } from '~/assets/js/seo/title.js';
import { mapGetters } from 'vuex'
const environment = process.env.NODE_ENV || 'production';
const envSet = require(`~/api/env.${environment}.js`)

export default {

	data() {

		var array = [
			{
				scale : '1.0',
				isActive : true
			},
			{
				scale : '1.5',
				isActive : false
			},
			{
				scale : '2.5',
				isActive : false
			}
		]
		if( this.$device.isMobile ){
			array = [
				{
					scale : '1.0',
					isActive : false
				},
				{
					scale : '1.5',
					isActive : true
				},
				{
					scale : '2.5',
					isActive : false
				}
			]
		}

		return {
			select : {
				prev    : null,
				current : null
			},
			zoom : {
				scale : 1,
				array : array
			},
		}
	},

	components: {
	},

	methods: {
		onMouseEnterArchive( index ){
			this.select.current = index;
		},
		onMouseLeaveArchive( index ){
			this.select.prev = index;
		},
		onChanegeArchiveScale( item ){
			if( styleArchiveScroll ){
				for (var i = 0; i < this.zoom.array.length; i++) {
					this.zoom.array[i].isActive = false;
				}
				item.isActive = true;
				this.zoom.scale = Number( item.scale );
				styleArchiveScroll.onZoomInOut( this.zoom.scale );
			}
		}
	},

	computed: {
		...mapGetters([
			'projects',
			'archive'
		]),
	},

	head() {
		let _title = getPageTitle(this.$i18n.locale, 'Archives');
		let _description = this.$t.bind(this)("archives.description");
		if( _description.length > 120 ) _description = _description.substr(0,120)+'...';
		return {
			title: _title,
			meta: [
				{
					name: 'description',
					content: _description,
				}
			]
		}
	},

	async fetch ({ store, $http }) {

		//
		if( !store.getters.projects.length ){
			const request = `${envSet.staticUrl}/db/projects.json`;
			const response = await $http.$get( request );
			store.dispatch( 'setProjects', response );
		}

	},

	mounted(){
		ROUTE.onMounted( this.$store.$device, {
			current : { type : 'archive', slug : 'archive' },
			prev : null,
			next : null
		});
	},

	transition : {
		mode: 'out-in',
		css: false,
		beforeEnter( el ){
			ROUTE.beforeEnter( el );
		},
		enter( el, done ){
			ROUTE.enter( el, done );
		},
		afterEnter( el ){
			ROUTE.afterEnter( el );
		},
		leave( el, done ){
			ROUTE.leave(el, done);
		},
	}

}
